// 大禹路由
var dayu = [
	{// PC
		path: '/dayu',
		name: 'dayuHome',
		meta: {
			title: '大禹'
		},
		component: () => import('@/views/dayu/home/index')
	},
	{// PC
		path: '/dayuEn',
		name: 'dayuHomeEn',
		meta: {
			title: '大禹'
		},
		component: () => import('@/views/dayu/home/indexEn')
	},
	{// 移动
		path: '/dayu/m',
		name: 'dayum',
		redirect: '/dayu/m/home',
		meta: {
			title: '大禹'
		}
	},
	{// 健康列表
		path: '/dayu/health',
		name: 'dayuHealth',
		meta: {
			title: '大禹-健康频道'
		},
		component: () => import('@/views/dayu/health/index')
	},
	{// 健康列表-详情
		path: '/dayu/health/detail/:id',
		name: 'dayuHealthDetail',
		meta: {
			title: '大禹-健康频道-详情'
		},
		component: () => import('@/views/dayu/health/detail')
	},
	{// 健康商城
		path: '/dayu/shop',
		name: 'dayuShop',
		meta: {
			title: '大禹-健康商城'
		},
		component: () => import('@/views/dayu/shop/index')
	},
	{// 在线咨询
		path: '/dayu/online',
		name: 'dayuOnline',
		meta: {
			title: '大禹-在线咨询'
		},
		component: () => import('@/views/dayu/online/index')
	},
	{// 课程计划
		path: '/dayu/course',
		name: 'dayuCourse',
		meta: {
			title: '大禹-课程计划'
		},
		component: () => import('@/views/dayu/course/list')
	},
	{// 课程计划
		path: '/dayu/course/detail/:id',
		name: 'dayuCourseDtail',
		meta: {
			title: '大禹-课程计划-详情'
		},
		component: () => import('@/views/dayu/course/detail')
	},
	{// 课程计划
		path: '/dayu/course/start/:id',
		name: 'dayuCourseStart',
		meta: {
			title: '大禹-开启课程计划'
		},
		component: () => import('@/views/dayu/course/start')
	},
	
	{// 首页
		path: '/dayu/m/home',
		name: 'dayumHome',
		meta: {
			title: '大禹'
		},
		component: () => import('@/views/dayu/m/home')
	},
	{// 健康列表
		path: '/dayu/m/health',
		name: 'dayuHealth',
		meta: {
			title: '大禹-健康频道'
		},
		component: () => import('@/views/dayu/m/health/index')
	},
	{// 健康列表-详情
		path: '/dayu/m/health/detail/:id',
		name: 'dayuHealthDetail',
		meta: {
			title: '大禹-健康频道-详情'
		},
		component: () => import('@/views/dayu/m/health/detail')
	},
	{// 在线咨询
		path: '/dayu/m/online',
		name: 'dayuOnline',
		meta: {
			title: '大禹-在线咨询'
		},
		component: () => import('@/views/dayu/m/online/index')
	},
	{// 课程计划
		path: '/dayu/m/course',
		name: 'dayuCourse',
		meta: {
			title: '大禹-课程计划'
		},
		component: () => import('@/views/dayu/m/course/index')
	},
	
	// 二维码失效
	{
		path: '/dayu/m/codeErr',
		name: 'dayumCodeErr',
		meta: {
			title: '二维码已失效'
		},
		component: () => import('../views/dayu/m/codeErr/index')
	}
];

export default dayu;